import { SVGProps } from 'react';

const IconMilkStage = ({
  height = '10px',
  width = '8px',
  color = '#E99921',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill={color}
    {...props}
  >
    <g clipPath="url(#clip0_11791_202669)">
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.08342 1.10523C4.62282 1.03689 3.92584 0.933489 3.30235 1.14892C2.74628 1.34105 2.44162 1.65683 2.30978 2.09636C2.20152 2.4573 2.26466 5.25452 2.30978 6.60802C2.43018 7.04415 2.74628 7.74757 2.98666 8.09687C3.36105 8.64088 4.97153 9.76618 5.46794 9.85642C5.96436 9.94665 7.63367 8.69502 8.03972 8.09687C8.44039 7.50666 8.71647 6.78849 8.71647 6.60802C8.71647 6.58746 8.718 6.48975 8.72041 6.33606C8.7349 5.41028 8.78117 2.45451 8.71647 2.09636C8.64103 1.67872 8.2054 1.21464 7.664 1.07027C7.28411 0.968968 6.5266 1.04855 5.98882 1.10505C5.76017 1.12907 5.57124 1.14892 5.46794 1.14892C5.37791 1.14892 5.24526 1.12924 5.08342 1.10523ZM8.385 6.46899H2.65528C2.565 8.00296 5.27195 9.58204 5.54265 9.58204C6.17429 9.58204 8.43012 7.68714 8.385 6.46899Z"
        stroke={color}
        strokeWidth="0.4"
      />
    </g>
    <defs>
      <clipPath id="clip0_11791_202669">
        <rect x="0.5" width="10" height="10" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconMilkStage;
